import React from 'react';
import styles from './LocationSelectorModal.module.scss';

export interface DentistLocation {
  id: number;
  address: string;
  removed?: number;
  deactivated?: number;
  isUpdated?: number;
  country?: string;
  stripeCustomerId?: string | null;
  revenueStripeCustomerId?: string | null;
  isCardValid?: number;
  revenuePaymentInfoValid?: number;
  primaryContact?: string;
  parking?: string;
  avgApptTime?: string;
  radiography?: string;
  ultrasonic?: string;
  charting?: string;
  software?: string;
}

interface LocationSelectorModalProps {
  isOpen: boolean;
  dateKey?: string; // YYYY-MM-DD, if selecting for a specific date
  locations: DentistLocation[];
  jobsPerLocationCount?: Record<number, number>; // locationId -> count for that date
  onSelect: (location: DentistLocation) => void;
  onClose: () => void;
}

const MAX_JOBS_PER_LOCATION = 20;

const LocationSelectorModal: React.FC<LocationSelectorModalProps> = ({
  isOpen,
  dateKey,
  locations,
  jobsPerLocationCount = {},
  onSelect,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>For Which Location?</h2>
          <div className={styles.locationList}>
            {locations
              .filter((loc) => loc.removed !== 1)
              .map((loc) => {
                const count = jobsPerLocationCount[loc.id] || 0;
                const reachedMax = count >= MAX_JOBS_PER_LOCATION;
                const isDeactivated = !!loc.deactivated;
                const disabled = reachedMax || isDeactivated;
                return (
                  <button
                    key={loc.id}
                    className={styles.locationItem}
                    disabled={disabled}
                    onClick={() => onSelect(loc)}
                    aria-disabled={disabled}
                    title={
                      reachedMax
                        ? `This location has reached its maximum of ${MAX_JOBS_PER_LOCATION} shifts for ${dateKey || 'this date'}`
                        : isDeactivated
                        ? 'Shift Posting Disabled for this location'
                        : 'Select location'
                    }
                  >
                    <div className={styles.address}>{loc.address}</div>
                    {reachedMax && (
                      <div className={styles.badge}>Max {MAX_JOBS_PER_LOCATION}</div>
                    )}
                    {isDeactivated && (
                      <div className={styles.badge}>Deactivated</div>
                    )}
                  </button>
                );
              })}
          </div>
          <div className={styles.modalActions}>
            <button className={styles.cancelButton} onClick={onClose}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationSelectorModal;

